import BaseModelAPI from '../BaseModelAPI';

export default class AuditLoginList extends BaseModelAPI {

	static entity = 'auditloginlist'
	static entityName = 'auditlogin';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
